import { useState } from "react";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import { ActiveCell, EditCommandCell, SignatureCell } from "../GridComponents";
import EditDepartment from "./EditDepartments";
import { useDepartments, updateDepartment } from "services/departmentService";
import { toast } from "react-toastify";
import { Loader } from "@progress/kendo-react-indicators";
import { GridLoader } from "components/GridLoader";

const DepartmentList = () => {
  const [openForm, setOpenForm] = useState(false);
  const [editItem, setEditItem] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { data: departments, loading } = useDepartments();

  const enterEdit = (item) => {
    setOpenForm(true);
    setEditItem(item);
  };

  const handleSubmit = async (event) => {
    setIsSubmitting(true);
    try {
      const data = {
        code: event.code,
        name: event.name,
        active: event.active,
      };

      const result = await updateDepartment(event.departmentID, data);

      if (result.success) {
        toast.success("Department updated successfully");
        setOpenForm(false);
      } else {
        toast.error("Failed to update department");
      }
    } catch (error) {
      toast.error("Error updating department");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancelEdit = () => {
    setOpenForm(false);
  };

  const MyEditCommandCell = (props) => (
    <EditCommandCell {...props} enterEdit={enterEdit} />
  );

  return (
    <div className="settings-grid h-100">
      <Grid
        data={departments}
        style={{ height: "100%", width: "max-content", maxWidth: "100%" }}
        showLoader={loading}
        loader={
          <div style={{ height: "50px" }}>
            <GridLoader />
          </div>
        }
      >
        <GridNoRecords>
          {loading ? (
            <span></span>
          ) : (
            departments && departments?.length === 0 && "No records available"
          )}
        </GridNoRecords>
        <Column field="name" title=" " cell={SignatureCell} width="80px" />
        <Column field="code" title="Code" width="100px" />
        <Column field="name" title="Name" width="180px" />
        <Column
          cell={ActiveCell}
          title="Active"
          field="active"
          width="50px"
        />
        <Column title="Edit" cell={MyEditCommandCell} width="40px" />
      </Grid>

      {openForm && (
        <EditDepartment
          cancelEdit={handleCancelEdit}
          onSubmit={handleSubmit}
          item={editItem}
          isSubmitting={isSubmitting}
        />
      )}
    </div>
  );
};

export default DepartmentList;
